import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const clientOnlyGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.initialized$.pipe(
    filter(initialized => initialized),
    take(1),
    map(() => {
      if (authService.getCurrentUser()?.role === 'SUPER_ADMIN') {
        return router.createUrlTree(['/admin/dashboard']);
      }
      return true;
    })
  );
};
